document.addEventListener('DOMContentLoaded', function() {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.isOpen = false;
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        this.close(true);
        return;
      }
      this.getSearchResults(searchTerm);
    }

    onFocus() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;
      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    getSearchResults(searchTerm) {
      this.setLiveRegionLoadingState();
      fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          this.close();
          console.error(error);
        });
    }

    setLiveRegionLoadingState() {
      this.setAttribute('loading', true);
      this.predictiveSearchResults.setAttribute('loading', true);
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.setAttribute('results', true);

      const resultItems = this.predictiveSearchResults.querySelectorAll(".predictive-search__results-item");
      let visibleCount = 0;

      resultItems.forEach(item => {
        const tags = item.dataset.tags;
        if (!tags || !tags.includes('tuotteet')) {
          item.remove();
        } else {
          visibleCount++;
        }
      });

      if (visibleCount === 0) {
        this.predictiveSearchResults.innerHTML = `<p class="predictive-search__no-results">Ei hakutuloksia hakusanalle "${this.getQuery()}"</p>`;
      }

      this.setLiveRegionResults();
      this.open();
    }

    setLiveRegionResults() {
      this.removeAttribute('loading');
      this.predictiveSearchResults.removeAttribute('loading');
    }

    open() {
      this.predictiveSearchResults.classList.add('predictive-search--has-results');
      this.predictiveSearchResults.style.display = 'block';
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }

    close(clearSearchTerm = false) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }
      this.predictiveSearchResults.classList.remove('predictive-search--has-results');
      this.predictiveSearchResults.style.display = 'none';
      this.input.setAttribute('aria-expanded', false);
      this.removeAttribute('loading');
      this.isOpen = false;
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
});
